export default "__VITE_ASSET__b83a3258__"